module.exports = __webpack_public_path__ + "img/consulta-cesantia.13d09b31.png";